import { defineComponent as _defineComponent } from 'vue'
import TileCard from '@/app/components/common/boxGrid/TileCard.vue';
import TradingLimits from 'ah-trades/src/components/limitsAndCollateral/TradingLimits.vue';
import PostedCollateral from 'ah-trades/src/components/limitsAndCollateral/PostedCollateral.vue';
import ManageCollateral from 'ah-trades/src/components/limitsAndCollateral/manageCollateral/ManageCollateral.vue';
import { computed, watch } from 'vue';
import { useRequestManager } from 'ah-common-lib/src/requestManager/useRequestManager';
import { ClientRiskProfileReport } from 'ah-api-gateways';
import LoadingOverlay from 'ah-common-lib/src/common/components/overlays/LoadingOverlay.vue';
import { useAuthStore } from '@/app/store/authStore';
import { useWalletsStore } from '@/app/store/walletsModule';


export default /*#__PURE__*/_defineComponent({
  __name: 'LimitsAndCollateralManagement',
  props: {
  oboClientId: {
    type: String,
  },
},
  setup(__props) {

const props = __props;



const requestManager = useRequestManager().manager;

const walletStore = useWalletsStore();

const authStore = useAuthStore();

const clientId = computed(() => props.oboClientId ?? authStore.loggedInIdentity?.client?.id);

const clientRiskProfileReportData = computed<ClientRiskProfileReport | null>(() => {
  if (clientId.value) {
    return walletStore.getClientRiskProfile(clientId.value);
  }
  return null;
});

function loadClientRiskProfileReport() {
  if (!clientId?.value) {
    throw 'Cannot load client risk profile report with incomplete data';
  }

  return requestManager.newPromise(
    'loadClientRiskProfileReport',
    walletStore.loadClientRiskProfile({ force: true, clientId: clientId.value })
  );
}

watch(
  clientId,
  () => {
    if (clientId.value) {
      loadClientRiskProfileReport();
    }
  },
  { immediate: true }
);

return { __sfc: true,props, requestManager, walletStore, authStore, clientId, clientRiskProfileReportData, loadClientRiskProfileReport, TileCard, TradingLimits, PostedCollateral, ManageCollateral, LoadingOverlay }
}

})